import { AppLayoutMode } from '@monetize/types/app';

/** Left sidebar width in px: collapsed (`overlay`) and expanded (`static`). */
export const APP_SIDEBAR_WIDTH: Record<AppLayoutMode, number> = {
  overlay: 68,
  static: 208,
};
